import { TrackEventActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/TrackEventActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { ActionFeatures } from '../ActionFeatures';
import '../Actions.scss';
export class TrackEventActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', '$rootScope', 'UndoRedoService', 'state', 'CurrentApplicationService', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, $timeout, $translate, $rootScope, UndoRedoService, state, CurrentApplicationService, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.CurrentApplicationService = CurrentApplicationService;
        this.isEditing = false;
        this.init();
    }
    async init() {
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.analyticsHidingEventTrackLabelandValueFT = await ActionFeatures.analyticsHidingLabelandValueEnabled();
        this.$timeout(() => {
            this.trackEventForm.action.$setDirty();
            this.trackEventForm.category.$setDirty();
            this.action.settings.value && this.trackEventForm.value.$setDirty();
            this.checkValidInputs();
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    checkValidInputs() {
        if (!this.action.settings.action) {
            this.trackEventForm.action.$invalid = true;
            this.trackEventForm.action.$valid = false;
        }
        if (!this.action.settings.category) {
            this.trackEventForm.category.$invalid = true;
            this.trackEventForm.category.$valid = false;
        }
        if (!this.checkRegex(this.action.settings.value)) {
            this.trackEventForm.value.$invalid = true;
            this.trackEventForm.value.$valid = false;
        }
    }
    checkRegex(val) {
        if (/^\{\{.+\}\}$|^[0-9]+(\.[0-9]{1,3})?$/.test(val)) {
            return true;
        }
        else {
            return false;
        }
    }
    checkValue(val) {
        if (val && val.length > 0 && !this.checkRegex(val)) {
            this.trackEventForm.value.$invalid = true;
            this.trackEventForm.value.$valid = false;
        }
        else {
            this.trackEventForm.value.$invalid = false;
            this.trackEventForm.value.$valid = true;
        }
        this.save();
    }
    onBlur() {
        this.isEditing = false;
        if (this.$title.length === 0) {
            this.$title = this.$translate.instant('builder-tabs-actions.trackEvent.title');
            this.save();
        }
    }
    startEditing() {
        const input = document.getElementById('tracking-event-title');
        if (input) {
            input.focus();
        }
    }
    create() {
        return new TrackEventActionSettings();
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
}
TrackEventActionController.$inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', '$rootScope', 'UndoRedoService', 'state', 'CurrentApplicationService', '$scope', 'typeOfAction'];
